import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Shield Airplane Outline"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
  selector: 'app-icon-shield-airplane-outline',
  templateUrl: './icon-shield-airplane-outline.html',
  styleUrl: './icon-shield-airplane-outline.scss',
  standalone: false,
})
export class IconShieldAirplaneOutlineComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
